import React, { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { ALL_SERVICES } from 'shared-modules/constants/core';
import { getAllLabsRequest, getMyLabsRequestLoadingSelector } from 'shared-modules/redux/labs';
import { FX } from 'shared-modules/constants';
import { Spin } from '../../../../components';
import { Welcome } from './Welcome';
import { Strategies } from './Strategies';
import styles from './buildersSharePage.module.scss';

export const BuildersSharePage = memo(() => {
  const dispatch = useDispatch();
  const loading = useSelector(getMyLabsRequestLoadingSelector);
  const myLabs = useSelector((state) => state.labs.myLabs);

  useEffect(() => {
    dispatch(getAllLabsRequest());
  }, [dispatch]);

  if (loading) {
    return (
      <div className={styles.container}>
        <Spin />
      </div>
    );
  }
  // TS-6302 一時的にETFとCFDのシェアを表示しないようにしている
  if (ALL_SERVICES.filter((value) => value === FX).some((serviceId) => !_.isEmpty(myLabs[serviceId]))) {
    return <Strategies />;
  }
  return <Welcome />;
});
